export enum EmployeeArchivedEnum {
    Archived = "Archived",
}